import { Subject, Subscription } from 'rxjs';
import { transformToChatMessage } from 'src/javascripts/services/messageHelpers';
import { ChatMessage, MultipartMessage, Shop } from 'src/javascripts/shared/chat';

export default class WidgetMessageService {
  messages: ChatMessage[];
  private subject: Subject<ChatMessage[]>;
  private subscription?: Subscription;
  private apiPath: string;
  private channels: Pusher.Channel[];

  constructor(shops: Shop[], private pusher: Pusher.Pusher) {
    this.apiPath = `/widget_api/messages?${shops.map(shop => `shop_ids[]=${shop.id}`).join('&')}`;
    this.channels = shops.map(shop => this.pusher.subscribe(`public-broadcasts-${shop.id}`));
    this.subject = new Subject();
    this.messages = [];
  }

  subscribe(observer: (messages: ChatMessage[]) => void) {
    this.channels.forEach(channel => channel.bind('new_message', this.addNewMessage, this));
    this.subscription = this.subject.subscribe(observer);
  }

  unsubscribe() {
    this.channels.forEach(channel => channel.unbind('new_message', this.addNewMessage, this));
    this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  async loadOlderMessages() {
    const olderMessages: ChatMessage[] = await fetch(this.apiPath)
      .then(response => this.parseResponse(response))
      .then(messages => messages.filter(message => !this.messages.map(message => message.id).includes(message.id)))
      .then(messages => messages.map(transformToChatMessage))
      .catch(() => null);
    if (olderMessages?.length) {
      this.messages = [...this.messages, ...olderMessages];
      this.subject.next(this.messages);
    }
  }

  addNewMessage(message: MultipartMessage) {
    const messageIds = this.messages.map(message => message.id);
    if (!messageIds.includes(message.id)) {
      this.messages = [transformToChatMessage(message), ...this.messages];
      this.subject.next(this.messages);
    }
  }

  private parseResponse(response: Response) {
    const regex = /<([^>]*)>; rel="next"/;
    const match = response.headers.get('Link')?.match(regex);
    if (match) {
      this.apiPath = match[1];
    }
    return response.json();
  }
}
